import { UsersItemList } from "../UsersItemList/UsersItemList";
import { SubscribersList } from "../SubscribersList/SubscribersList";
import React, { useEffect, useState } from "react";
import { appAxiosInstance } from "../../../api";
import { toast } from "react-toastify";
import s from "./UsersList.module.css";
import { Loader } from "../../../components/Loader/loader";

interface IUserRequest {
    id: number;
    name: string;
    email: string;
    linkPhoto: string;
    role: string;
    phoneNumber: string;
    registerDate: string;
    colorType: string;
    statusSubscribe: string;
    numberOfDayLogin: number;
    isFreePeriod: boolean;
}

interface IUserResponse {
    countRecords: number;
    users: IUserRequest[];
}

export default function UsersList() {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [allItems, setAllItems] = useState(0);
    const [users, setUsers] = useState<Array<IUserRequest>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [activeTabRecommendation, setActiveTabRecommendation] = useState<boolean>(true);
    const [filterType, setFilterType] = useState<'all' | 'withSubscription' | 'withoutSubscription'>('all');
    const [searchId, setSearchId] = useState<string>('');
    const [searchEmail, setSearchEmail] = useState<string>('');
    const [searchName, setSearchName] = useState<string>('');
    const [searchPhoneNumber, setSearchPhoneNumber] = useState<string>('');

    const getUsers = async () => {
        try {
            setIsLoading(true);
            const UsersResponse = await appAxiosInstance.post<IUserResponse>('/mobile/users', {
                currentPage: currentPage,
                itemsPerPage: itemsPerPage,
                filterType: filterType,
                searchId: searchId.trim(),
                searchName: searchName.trim(),
                searchEmail: searchEmail.trim(),
                searchPhoneNumber: searchPhoneNumber.trim()
            });

            const usersList = UsersResponse.data.users;

            if (usersList) {
                setUsers(usersList);
                setAllItems(UsersResponse.data.countRecords);
            } else {
                setUsers([]);
            }

        } catch (error) {
            toast.error('Ошибка при получении списка пользователей');
            setUsers([]);
        } finally {
            setIsLoading(false);
        }
    };

    const totalPages = Math.ceil(allItems / itemsPerPage);

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };

    const handleFilterChange = (filter: 'all' | 'withSubscription' | 'withoutSubscription') => {
        setFilterType(filter);
        setCurrentPage(1);
        clearAllFilters();
    };

    const handleTabChange = (isRecommendation: boolean) => {
        setActiveTabRecommendation(isRecommendation);
        setCurrentPage(1);
        clearAllFilters();
    };

    const clearAllFilters = () => {
        setSearchId('');
        setSearchEmail('');
        setSearchName('');
        setSearchPhoneNumber('');
    };

    const handleSearchClick = () => {
        setCurrentPage(1);
        getUsers();
    };

    const handleClearSearch = () => {
        clearAllFilters();
        setCurrentPage(1);
        setTimeout(() => getUsers(), 0);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    useEffect(() => {
        if (activeTabRecommendation) {
            getUsers();
        }
    }, [currentPage, activeTabRecommendation, filterType]);

    const renderContent = () => {
        if (activeTabRecommendation) {
            return (
                <div className={s.container}>
                    <div className={s.selectorWrapper}>
                        <div className={s.selector}>
                            <div
                                className={`${s.selectorItem} ${filterType === 'all' ? s.active : ''}`}
                                onClick={() => handleFilterChange('all')}
                            >
                                Все
                            </div>
                            <div
                                className={`${s.selectorItem} ${filterType === 'withSubscription' ? s.active : ''}`}
                                onClick={() => handleFilterChange('withSubscription')}
                            >
                                С подпиской
                            </div>
                            <div
                                className={`${s.selectorItem} ${filterType === 'withoutSubscription' ? s.active : ''}`}
                                onClick={() => handleFilterChange('withoutSubscription')}
                            >
                                Без подписки
                            </div>
                        </div>
                    </div>

                    <div className={s.header}>
                        <span className={s.count}>Всего: {allItems}</span>
                        <div className={s.searchContainer}>
                            <div className={s.searchGrid}>
                                <div className={s.searchInputWrapper}>
                                    <input
                                        type="text"
                                        className={s.searchInput}
                                        placeholder="Поиск по ID"
                                        value={searchId}
                                        onChange={(e) => setSearchId(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                    />
                                    {searchId && (
                                        <button
                                            className={s.clearSearchBtn}
                                            onClick={() => setSearchId('')}
                                            type="button"
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                                <div className={s.searchInputWrapper}>
                                    <input
                                        type="text"
                                        className={s.searchInput}
                                        placeholder="Поиск по имени"
                                        value={searchName}
                                        onChange={(e) => setSearchName(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                    />
                                    {searchName && (
                                        <button
                                            className={s.clearSearchBtn}
                                            onClick={() => setSearchName('')}
                                            type="button"
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                                <div className={s.searchInputWrapper}>
                                    <input
                                        type="text"
                                        className={s.searchInput}
                                        placeholder="Поиск по email"
                                        value={searchEmail}
                                        onChange={(e) => setSearchEmail(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                    />
                                    {searchEmail && (
                                        <button
                                            className={s.clearSearchBtn}
                                            onClick={() => setSearchEmail('')}
                                            type="button"
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                                <div className={s.searchInputWrapper}>
                                    <input
                                        type="text"
                                        className={s.searchInput}
                                        placeholder="Поиск по телефону"
                                        value={searchPhoneNumber}
                                        onChange={(e) => setSearchPhoneNumber(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                    />
                                    {searchPhoneNumber && (
                                        <button
                                            className={s.clearSearchBtn}
                                            onClick={() => setSearchPhoneNumber('')}
                                            type="button"
                                        >
                                            ✕
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className={s.searchActions}>
                                <button
                                    className={s.searchBtn}
                                    onClick={handleSearchClick}
                                >
                                    Поиск
                                </button>
                                <button
                                    className={s.clearBtn}
                                    onClick={handleClearSearch}
                                >
                                    Очистить
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={s.tableWrapper}>
                        <table className={s.table}>
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Имя</th>
                                <th>Email</th>
                                <th>Номер телефона</th>
                                <th>Дата регистрации</th>
                                <th>Фото</th>
                                <th>Цветотип</th>
                                <th>Дней входа</th>
                                <th>Подписка</th>
                            </tr>
                            </thead>
                            <tbody>
                            {users.length === 0 ? (
                                <tr>
                                    <td colSpan={9} className={s.emptyCell}>
                                        'Ничего не найдено'
                                    </td>
                                </tr>
                            ) : (
                                users.map((user: IUserRequest) => (
                                    <UsersItemList
                                        key={user.id}
                                        user={user}
                                    />
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>

                    {totalPages > 1 && (
                        <div className={s.pagination}>
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                className={s.pageButton}
                            >
                                ← Назад
                            </button>
                            <span className={s.pageInfo}>
                                Страница {currentPage} из {totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                className={s.pageButton}
                            >
                                Вперед →
                            </button>
                        </div>
                    )}
                </div>
            );
        } else {
            return <SubscribersList />;
        }
    };

    return (
        <div>
            {isLoading ? (
                <div className={s.loadingContainer}>
                    <Loader />
                </div>
            ) : (
                <div>
                    <div className={s.tabs}>
                        <button
                            className={`${s.tab} ${activeTabRecommendation ? s.activeTab : ''}`}
                            onClick={() => handleTabChange(true)}
                        >
                            Пользователи
                        </button>
                        <button
                            className={`${s.tab} ${!activeTabRecommendation ? s.activeTab : ''}`}
                            onClick={() => handleTabChange(false)}
                        >
                            Подписчики
                        </button>
                    </div>

                    {renderContent()}
                </div>
            )}
        </div>
    );
}